var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -569.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/News",
    transform: "translate(1206.000000, 569.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,3.90625 L4,29.09375 C4,30.6989687 5.343,32 7,32 L7,32 L4,32 C2.343,32 1,30.6989687 1,29.09375 L1,29.09375 L1,3.90625 L4,3.90625 Z M28,1 C29.657,1 31,2.30103125 31,3.90625 L31,3.90625 L31,32 L10,32 C8.343,32 7,30.6989687 7,29.09375 L7,29.09375 L7,1 Z M26,24.25 L10,24.25 C10,25.3195 10.895,26.1875 12,26.1875 L12,26.1875 L28,26.1875 C28,25.1170313 27.104,24.25 26,24.25 L26,24.25 Z M26,19.40625 L10,19.40625 C10,20.47575 10.895,21.34375 12,21.34375 L12,21.34375 L28,21.34375 C28,20.2732813 27.104,19.40625 26,19.40625 L26,19.40625 Z M26,14.5625 L10,14.5625 C10,15.632 10.895,16.5 12,16.5 L12,16.5 L28,16.5 C28,15.4295313 27.104,14.5625 26,14.5625 L26,14.5625 Z M17,4.875 L10,4.875 L10,11.65625 L17,11.65625 L17,4.875 Z",
    id: 226
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonNews);
export default __webpack_public_path__ + "static/media/common-news.efd8f592.svg";
export { ForwardRef as ReactComponent };